export enum SessionKey
{
    LANGUAGE                    = "language"        ,
    LOCALE                      = "locale"          ,
    USER                        = "user"            ,

    CODE                        = "code"            ,

    MENU_CONF                   = "menu_conf"       ,
    ORGANIZATION                = "organization"    ,
    HUB                         = "hub"             ,
    GUIDED_CREATION             = "guided-creation" ,
} 

export function isSessionKey( value: any )
{
    return Object.values(SessionKey).includes(value)
}